import { UpgradeIds } from '../enums'
import type { UpgradeFactoryInput } from '../../../../types/UpgradeFactoryInput'
import { DepartmentIds } from '../../departments'
import TwoExponentRiseFactory from './factory'
import departments from '../../departments'

const creatives: UpgradeFactoryInput[] = [
	{
		name: 'Random Vote Generator',
		description:
			'Upgrade machines to generate votes based on a random number generator.'
	},
	{
		name: 'Convenience Fee Calculator',
		description:
			'Add extra fees for breathing near the machines. Very convenient!'
	},
	{
		name: 'Error 404: Vote Not Found',
		description:
			'Machines now randomly display error messages in ancient hieroglyphics.'
	},
	{
		name: 'Quantum Voting Booth',
		description:
			'Votes exist in multiple states until observed by an accountant.'
	},
	{
		name: 'Time-Traveling Ballots',
		description:
			'Collect votes from the past and future simultaneously. Temporal paradoxes included.'
	},
	{
		name: 'Parallel Universe Polling',
		description:
			'Count votes from alternate realities where everyone votes twice.'
	},
	{
		name: 'Void Ballot System',
		description:
			'Send all ballots directly to the void. Very efficient disposal method!'
	}
]

const array = TwoExponentRiseFactory(
	creatives,
	DepartmentIds['Election Machines'],
	departments[DepartmentIds['Election Machines']].basePrice * 3,
	UpgradeIds.ElmExponent1
)

export default array
